<script>
    import {_, number, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";
    import {blueprintsChestIcon, blueprintsChestKeys, resolveTitle} from './naval-items.js';

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        // Rows are keyed on the server `type` ("blueprintsChestSmall" /
        // "blueprintsChestMedium"); gameItem.amount is how many blueprints the
        // chest yields, which the description interpolates.
        const type = gameItem.type;
        const keys = blueprintsChestKeys(type);
        const blueprints = Number(gameItem.amount) || 1;

        itemDetails.title = resolveTitle({
            key: keys.title,
            fallback: 'Blueprints Chest',
            translate: (k) => $_(k, {values: {AMOUNT: $number(blueprints)}}),
        });
        itemDetails.description = resolveTitle({
            key: keys.description,
            fallback: '',
            translate: (k) => $_(k, {values: {AMOUNT: $number(blueprints)}}),
        });
        itemDetails.amount = item.amount;
        itemDetails.icon = blueprintsChestIcon(type);
        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
